// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"9521":"ab7f3810b7284b856dd5","9819":"d2961b3f8dc85a2b647f"}[chunkId] + ".chunk.js";
};